import React from 'react';
import type { CountRendereProps } from '../../../../common/ui/types.tsx';
import { IssueCount } from './issue-count/main.tsx';

const IssueCountRenderer = ({
	issueNavigatorPageInfo,
	totalIssueSearchResultCount,
}: CountRendereProps) => {
	const startIssueRange = issueNavigatorPageInfo?.firstIssuePosition ?? 0; // TODO: counrRendererData will be fetched thorugh relay framents
	const endIssueRange = issueNavigatorPageInfo?.lastIssuePosition ?? 0;
	const total = totalIssueSearchResultCount ?? 0;

	return (
		<IssueCount startIssueRange={startIssueRange} endIssueRange={endIssueRange} total={total} />
	);
};

export default IssueCountRenderer;
